import React, { useRef, useEffect } from 'react';
import { Editor } from '@toast-ui/react-editor';
import '@toast-ui/editor/dist/toastui-editor.css';

const ToastEditor = ({
  content,
  onChange,
  placeholder = "Enter content...",
  height = "400px",
  initialEditType = "wysiwyg", // wysiwyg, markdown
  previewStyle = "vertical", // vertical, tab
  hideModeSwitch = false,
  usageStatistics = false
}) => {
  const editorRef = useRef(null);

  useEffect(() => {
    if (editorRef.current && content !== undefined) {
      const editorInstance = editorRef.current.getInstance();
      const currentContent = editorInstance.getMarkdown();
      
      // Only update if content is different to avoid infinite loops
      if (currentContent !== content) {
        editorInstance.setMarkdown(content || '');
      }
    }
  }, [content]);

  const handleChange = () => {
    if (editorRef.current && onChange) {
      const editorInstance = editorRef.current.getInstance();
      const markdownContent = editorInstance.getMarkdown();
      onChange(markdownContent);
    }
  };

  return (
    <div className="toast-editor-container">
      <Editor
        ref={editorRef}
        initialValue={content || ''}
        previewStyle={previewStyle}
        height={height}
        initialEditType={initialEditType}
        useCommandShortcut={true}
        usageStatistics={usageStatistics}
        hideModeSwitch={hideModeSwitch}
        placeholder={placeholder}
        onChange={handleChange}
        toolbarItems={[
          ['heading', 'bold', 'italic', 'strike'],
          ['hr', 'quote'],
          ['ul', 'ol', 'task', 'indent', 'outdent'],
          ['table', 'image', 'link'],
          ['code', 'codeblock'],
          ['scrollSync']
        ]}
      />
    </div>
  );
};

export default ToastEditor;
